<template>
  <div class="container u-flex-col u-col-center" v-cloak>
    <template v-if="applyDatas">
      <div class="top-con pr">
        <!-- <div class="bg-div pa" /> -->
        <div class="u-flex pr">
          <div class="title-left">
            <h5>总待还款金额</h5>
            <h2>{{ applyDatas.totalAmount }}</h2>
            <p>
              {{ `${applyDatas.repayTypeTxt} 总利息${applyDatas.totalInterest}元` }}
            </p>
          </div>
          <div class="title-right">
            <span @click="handleMakeCall">{{ `客服电话：${phoneNumber}` }}</span>
          </div>
        </div>
      </div>

      <!-- 分期详情列表 -->
      <div class="bottom-con">
        <van-cell-group v-for="(i, idx) in applyDatas.plans" :key="idx">
          <van-cell :border="false">
            <template #title>
              <span class="custom-title">{{ i.periodTxt }}</span>
              <p class="repayDate">{{ i.repayDate }}待还</p>
            </template>

            <template #right-icon>
              <div>
                <p class="principal">{{ `${i.principal}` }}</p>
                <p class="interest">含利息{{ `${i.interest}` }}</p>
              </div>
            </template>
          </van-cell>
        </van-cell-group>
      </div>
    </template>
  </div>
</template>
<script>
import * as API_Common from '@/api/common.js'

export default {
  name: 'RepaymentPlan',
  data() {
    return {
      client: this.MixinClientBrowser(), // 设备
      phoneNumber: '95713',
      applyId: this.$route.query.applyId, // 计划ID
      applyDatas: {},
    }
  },
  mounted() {
    this.getApplyData()
  },
  methods: {
    // 获取还款计划信息
    getApplyData() {
      API_Common.getApplyData(this.applyId).then((res) => {
        if (res.code === 200) {
          this.applyDatas = res.data
        } else {
          this.$toast.fail(res.msg)
        }
      })
    },

    // 调用客户端拨打电话功能
    handleMakeCall() {
      const { client, phoneNumber } = this
      if (client === 'ios') {
        try {
          this.$bridge.callhandler('go2CallPhoneNum', { phoneNumber })
        } catch (err) {
          console.log('try---catch-调用IOS客户端方法报错')
        }
      } else if (client === 'android') {
        if (window.LoanMarketChina) {
          try {
            window.LoanMarketChina.go2CallPhoneNum(phoneNumber)
          } catch (err) {
            console.log('try---catch-调用安卓客户端方法报错')
          }
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  background: #f2f5fa;
  padding: 0.2rem 0.23rem 0.28rem 0.23rem;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;

  .bottom-con,
  .top-con {
    width: 100%;
    margin: 0;
  }
  .custom-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.28rem;
    color: #252525;
    line-height: 0.4rem;
  }
  .top-con {
    height: 2.805rem;
    margin: 0 0 0.2rem;
    background: #ffffff;
    border-radius: 0.14rem;

    .title-left {
      flex-grow: 2;
      font-family: PingFangSC, PingFang SC;
      h5 {
        font-weight: 400;
        font-size: 0.24rem;
        color: #333333;
        line-height: 0.33rem;
      }
      h2 {
        font-family: Roboto, Roboto;
        font-size: 0.7rem;
        color: #333333;
        line-height: 0.82rem;
        margin: 0.16rem 0;
      }
      p {
        font-weight: 400;
        font-size: 0.24rem;
        color: #868686;
        line-height: 0.33rem;
      }
    }
    .title-right {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 0.26rem;
      color: #e71a0f;
    }
    div.bg-div {
      width: 132%;
      height: 4.46rem;
      background: #3563fa;
      border-radius: 50%;
      left: -16%;
      top: -1.9rem;
    }

    div.pr {
      padding: 0.49rem 0.31rem 0.53rem 0.31rem;
      font-family: PingFangSC, PingFangSC-Regular;
      color: #868e9e;
      font-size: 0.24rem;

      > h5 {
        font-size: 0.26rem;
        font-weight: normal;
      }

      > h2 {
        font-size: 0.72rem;
        font-family: YOUSHEhaoshenti, YOUSHEhaoshenti-Regular;
        font-weight: normal;
        color: #111c31;
        margin: 0.16rem 0;
      }

      > span {
        font-size: 0.24rem;
        color: #3563fa;
        margin-top: 0.24rem;
      }
    }
  }

  .bottom-con {
    overflow-y: scroll;
    border-radius: 0.08rem;
    .van-cell {
      padding: 0.29rem 0.31rem 0.55rem 0.3rem;
    }
    .van-cell__title {
      font-size: 0.32rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: normal;
      color: #111c31;
    }
    .custom-title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 0.28rem;
      color: #252525;
      line-height: 0.4rem;
    }
    .repayDate {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 0.22rem;
      color: #b5b5b5;
      line-height: 0.3rem;
      margin-top: 0.12rem;
    }
    .principal {
      font-family: Roboto, Roboto;
      font-weight: 600;
      font-size: 0.28rem;
      color: #252525;
      line-height: 0.33rem;
      text-align: right;
      font-style: normal;
    }
    .interest {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 0.22rem;
      color: #aeaeae;
      line-height: 0.3rem;
      margin-top: 0.15rem;
    }
    .van-cell__label,
    .van-cell__value {
      font-size: 0.24rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: normal;
      color: #868e9e;
    }

    .van-hairline--top-bottom::after {
      display: none;
    }

    .period-title {
      color: #3563fa;
    }
  }
}
</style>
